export const BANK_SELECTOR_FETCH_SUBSTITUTES =
  'BANK_SELECTOR_FETCH_SUBSTITUTES';
export const BANK_SELECTOR_SUBSTITUTE_BANK = 'BANK_SELECTOR_SUBSTITUTE_BANK';

export type BankSelectorAction =
  | typeof BANK_SELECTOR_FETCH_SUBSTITUTES
  | typeof BANK_SELECTOR_SUBSTITUTE_BANK;

export interface BankSelectorActions {
  command: BankSelectorAction;
  data: any;
}
